export const sessionReportKeys = {
    all: ['sessionReport'] as const,
    availability: (centerId: string) => [...sessionReportKeys.all, 'availability', centerId] as const,
    /** coachId 가 비면 강사 미지정 요약 조회 */
    report: (centerId: string, yearMonth: string, ghostDays: number, coachId = '') =>
        [...sessionReportKeys.all, 'report', centerId, yearMonth, ghostDays, coachId] as const,
    /** 「수업 보기」 사용 가능 여부(서버에 기능이 있는지) */
    lessonsAvailability: (centerId: string) => [...sessionReportKeys.all, 'lessonsAvailability', centerId] as const,
    /** 수업 옮기기 — 한 수강권의 수업 목록(기간이 다르면 다른 캐시) */
    lessons: (centerId: string, membershipId: string, from = '', to = '') =>
        [...sessionReportKeys.all, 'lessons', centerId, membershipId, from, to] as const,
};
